import styled from "styled-components";

const verticalPosition = {
  top: "flex-start",
  bottom: "flex-end",
  center: "center",
};

const horizontalPosition = {
  left: "flex-start",
  right: "flex-end",
  center: "center",
  space: "space-between",
};

export const CardsGrid = styled("div")`
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
  padding: 0px 0px 0px 10px;
  
  @media(min-width: 768px){
    padding: 0px 0px 0px 0px;
  }
`;

export const Card = styled.div`
  background-color: #EDF6FF;
  border: 1px solid #E4E4E7;
  border-radius: 12px;
  padding: 25px 0px 22px 0px;
`

export const Center = styled("div") <{
  vertical: "top" | "center" | "bottom";
  horizontal: "left" | "center" | "right" | "space";
  gap?: number;
  column?: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: ${({ column }) => (column ? "column" : "row")};
  justify-content: ${({ horizontal }) => horizontalPosition[horizontal]};
  align-items: ${({ vertical }) => verticalPosition[vertical]};
  gap: ${({ gap }) => (gap ? gap : 0)}px;
`;

